import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextFieldData from "../../GeneralDisclosure/TextFiledData";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  IconButton,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { truncateNumber } from "../../../../utils/common";
import styles from "../../../../styles/gri/general.module.css";

const AddTable = ({
  title,
  addTables,
  setaddTables,
  errors,
  setErrors,
  inputData,
  DropDownData,
  defaultSegments,
  handleAdd,
  disabled,
  hide
}) => {
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [deleteDilog, setDeleteDialog] = useState(false);
  const [isFilleds, setIsFilled] = useState({});
  const [radiobtn, setRadioBtn] = useState("volume");
  const handleChangeselectTable = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, index, "handleChangeTable");
    const [main, sub, field] = name.split(".");

    setaddTables((prev) =>
      prev.map((table, index) => ({
        ...table, // Spread the existing table data
        [main]: {
          ...table[main], // Spread the main object
          [sub]: {
            ...table[main]?.[sub], // Spread the sub-object
            [field]: value, // Dynamically update the specific field
          },
        },
      })))
    //   setaddTables((prev) => {
    //   const newData = [...prev]; // Create a shallow copy of the array
    //   newData[index] = {
    //     ...newData[index], // Copy the object at the given index
    //     [main]: {
    //       ...newData[index][main],
    //       [sub]:{
    //        ...newData[index][main][sub],
    //         [field]: value,
    //       }
    //     }, // Update the specific field dynamically
    //   };
    //   return newData;
    // });
  };
  const handleChangeTable = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, index, "handleChangeTable");
    const [main, filed] = name.split(".");
    setaddTables((prev) => {
      const newData = [...prev]; // Create a shallow copy of the array
      newData[index] = {
        ...newData[index], // Copy the object at the given index
        [main]: {
          ...newData[index][main],
          [filed]: value,
        }, // Update the specific field dynamically
      };
      return newData;
    });
  };

  // const handleChangeNumberTable = (e, index) => {
  //   const { name, value } = e.target;
  //   if (!/^\d*$/.test(value)) return;
  //   console.log(name, value, index, addTables, "handleChangeTable");
  //   const [main, filed] = name.split(".");

  //   addTables.find((index) => {});

  //   setaddTables((prev) => {
  //     const newData = [...prev];
  //     let newPercentage = 0;
  //     if (main === "renewable" || main === "nonrenewable") {
  //       let totalInputMaterials =
  //         parseFloat(newData[index][main].totaInputMaterials) || 0;
  //       let totalRecycled =
  //         parseFloat(newData[index][main].totalRecycled) || 0;

  //       // If totalRecycled is being cleared (empty value) or reduced, clear totalInputMaterials
    

  //       if (
  //         filed === "totalRecycled" &&
  //         parseFloat(value) > totalInputMaterials
  //       ) {
  //         return prev; // Don't update state if input is invalid
  //       }
  //       console.log(filed,totalRecycled,parseFloat(value),parseFloat(value) > totalRecycled,"values")
  //       if (
  //         filed === "totalInputMaterials" &&
  //         parseFloat(value) < totalRecycled
  //       ) {
  //         // clear totaInputMaterials if exceeded
  //         newData[index][main].totalRecycled = "";
  //         // totalRecycled = 0;
    
  //         // ✅ still return newData so state updates
  //         // return newData;
  //       }
  //       if (totalRecycled > totalInputMaterials) {
  //         newData[index][main].totaInputMaterials = "";
  //         totalInputMaterials = 0; // also reset for calculation
  //       }
  //       // Calculate the percentage if totalInputMaterials is not 0
  //       if (totalInputMaterials !== 0) {
  //         newPercentage = (totalRecycled / totalInputMaterials) * 100;
  //       } else {
  //         newPercentage = 0; // Avoid dividing by zero, set to 0 if materials is 0
  //       }

  //       console.log("object", totalRecycled, totalInputMaterials);
  //     }
  //     // Create a shallow copy of the array
  //     newData[index] = {
  //       ...newData[index], // Copy the object at the given index
  //       [main]: {
  //         ...newData[index][main],
  //         [filed]: value,
  //         //   percentage: newPercentage,
  //       }, // Update the specific field dynamically
  //     };
  //     return newData;
  //   });
  // };

  const handleChangeNumberTable = (e, index) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    console.log(name, value, index, addTables, "handleChangeTable");
    const [main, filed] = name.split(".");

    setaddTables((prev) => {
      const newData = [...prev];
      let newPercentage = 0;
      
      if (main === "renewable" || main === "nonrenewable") {
        // Get current values
        const currentTotalInputMaterials = parseFloat(newData[index][main].totaInputMaterials) || 0;
        const currentTotalRecycled = parseFloat(newData[index][main].totalRecycled) || 0;
        
        // Handle totalRecycled changes
        if (filed === "totalRecycled") {
          const newTotalRecycled = parseFloat(value) || 0;
          
          // If totalRecycled is being cleared or reduced, clear totalInputMaterials
          // if (value === "" || value === null || value === undefined || newTotalRecycled < currentTotalRecycled) {
          //   newData[index] = {
          //     ...newData[index],
          //     [main]: {
          //       ...newData[index][main],
          //       [filed]: value,
          //       totaInputMaterials: "", // Clear totalInputMaterials
          //     },
          //   };
          //   return newData;
          // }
          if (
                    filed === "totalRecycled" &&
                    parseFloat(value) > currentTotalInputMaterials
                  ) {
                    return prev; // Don't update state if input is invalid
                  }
          
          // If new totalRecycled would exceed totalInputMaterials, clear totalInputMaterials
          // if (newTotalRecycled > currentTotalInputMaterials) {
            // newData[index] = {
            //   ...newData[index],
            //   [main]: {
            //     ...newData[index][main],
            //     [filed]: value,
            //     totaInputMaterials: "", // Clear totalInputMaterials
            //   },
            // };
            // return prev;
          // }
        }
        
        // Handle totalInputMaterials changes
        if (filed === "totaInputMaterials") {
          const newTotalInputMaterials = parseFloat(value) || 0;
          
          // If totalInputMaterials is reduced below totalRecycled, clear totalRecycled
          if (newTotalInputMaterials < currentTotalRecycled) {
            newData[index] = {
              ...newData[index],
              [main]: {
                ...newData[index][main],
                [filed]: value,
                totalRecycled: "", // Clear totalRecycled
              },
            };
            return newData;
          }
        }
        
        // Calculate percentage for display
        const updatedTotalInputMaterials = filed === "totaInputMaterials" ? (parseFloat(value) || 0) : currentTotalInputMaterials;
        const updatedTotalRecycled = filed === "totalRecycled" ? (parseFloat(value) || 0) : currentTotalRecycled;
        
        if (updatedTotalInputMaterials !== 0) {
          newPercentage = (updatedTotalRecycled / updatedTotalInputMaterials) * 100;
        } else {
          newPercentage = 0;
        }
        
        console.log("Updated values:", updatedTotalRecycled, updatedTotalInputMaterials, newPercentage);
      }
      
      // Update the field value
      newData[index] = {
        ...newData[index],
        [main]: {
          ...newData[index][main],
          [filed]: value,
        },
      };
      
      return newData;
    });
  };
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    console.log(name, value, index, "handleChangeTable");
    setaddTables((prev) => {
      const newData = [...prev]; // Create a shallow copy of the array
      newData[index] = {
        ...newData[index], // Copy the object at the given index
        [name]: value,
        // Update the specific field dynamically
      };
      return newData;
    });
  };
  useEffect(() => {
    checkIfAdded();
  }, [addTables, inputData]); // Run only when addTables or inputData change

  const flattenObject = (obj, prefix = "") => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = prefix ? `${prefix}.${key}` : key;
      if (typeof value === "object" && value !== null) {
        Object.assign(acc, flattenObject(value, newKey)); // Recursively flatten nested objects
      } else {
        acc[newKey] = value;
      }
      return acc;
    }, {});
  };

  const isFilled = (value) => {
    return (
      value !== undefined &&
      value !== "" &&
      value !== null &&
      !(Array.isArray(value) && value.length === 0)
    );
  };

  const checkIfAdded = () => {
    if (!Array.isArray(addTables)) {
      console.warn("⚠️ addTables is not an array!");
      return;
    }

    const newIsFilled = {};

    addTables.forEach((table, tableIndex) => {
      console.log(`🔍 Checking Table ${tableIndex}:`, table);

      if (typeof table !== "object" || table === null) {
        console.warn(`⚠️ Table ${tableIndex} is invalid!`);
        newIsFilled[tableIndex] = true; // Mark as incomplete if it's not a valid object
        return;
      }

      const flattenedTable = flattenObject(table);
      console.log(`📝 Flattened Table ${tableIndex}:`, flattenedTable);

      // Check if any required fields are empty
      const hasEmptyFields = Object.entries(flattenedTable)
        .filter(([key]) => !key.startsWith("measurementUnit"))
        .some(([, value]) => value === "" || value === null);
      // const hasEmptyFields = Object.values(flattenedTable).some(value => value === "" || value === null);
      console.log("findObjects", Object.values(flattenedTable));
      // Validate measurement unit rules
      const massActive = flattenedTable["measurementUnit.mass.active"] === true;
      const volumeActive =
        flattenedTable["measurementUnit.volume.active"] === true;
      const massRemark = flattenedTable["measurementUnit.mass.remark"];
      const volumeRemark = flattenedTable["measurementUnit.volume.remark"];

      const massValid = massActive ? isFilled(massRemark) : true;
      const volumeValid = volumeActive ? isFilled(volumeRemark) : true;

      console.log(
        `📌 Active Mass: ${massActive}, Remark: "${massRemark}" - Valid: ${massValid}`
      );
      console.log(
        `📌 Active Volume: ${volumeActive}, Remark: "${volumeRemark}" - Valid: ${volumeValid}`
      );

      // A table is complete if it has valid measurement units and no empty required fields
      const isComplete = massValid && volumeValid && !hasEmptyFields;

      console.log(
        `✅ Final Status for Table${!hasEmptyFields} ${tableIndex}: ${
          isComplete ? "Complete" : "Incomplete"
        }`
      );

      newIsFilled[tableIndex] = !isComplete; // Mark incomplete tables as true
    });

    // Ensure only the last table is marked incomplete
    // const lastIndex = addTables.length - 1;
    // Object.keys(newIsFilled).forEach((key) => {
    //   newIsFilled[key] = parseInt(key) === lastIndex;
    // });

    console.log("🛠️ Final Validation State:", newIsFilled);
    setIsFilled(newIsFilled);
  };

  const handleDeleteCountry = () => {
    console.log(deleteIndex, "delete country");
    setDeleteDialog(false);
    setaddTables((prev) => prev.filter((_, i) => i !== deleteIndex));
  };
  const handleRadioChange = (event, index) => {
    const { name } = event.target; // e.g., "measurementUnit.volume.remark"
    const [, selectedUnit] = name.split("."); // Extract "volume" or "mass"
    console.log(selectedUnit, "selectedUnit");

    setaddTables((prev) =>
      prev.map((table) => ({
        ...table,
        measurementUnit: {
          mass: { active: selectedUnit === "mass", remark: "" },
          volume: { active: selectedUnit === "volume", remark: "" },
        },
      }))
    );
  //   setaddTables((prev) => {
  //   const newData = [...prev]; // clone array

  //   newData[index] = {
  //     ...newData[index], // keep rest of the table row
  //     measurementUnit: {
  //       mass: {
  //         active: selectedUnit === "mass",
  //         remark: "",
  //       },
  //       volume: {
  //         active: selectedUnit === "volume",
  //         remark: "",
  //       },
  //     },
  //   };

  //   return newData;
  // });
  };

  return (
    <>
      <p className={styles.ques_heading} >{title}</p>
      {addTables.map((data, tableindex) => (
      <Box sx={{ mt: hide ? "-1rem" : "2rem", ml:"1.2rem" }}>
         <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <p style={{margin:0}}>{tableindex+1}. </p> 
           <p style={{margin:0}}>Product Name:</p>
            <TextField
              size="small"
              sx={{width:"22.5%"}}
              placeholder="Enter Text"
              name="productName"
              value={data?.productName}
              onChange={(e) => handleInputChange(e, tableindex)}
              disabled={disabled}
            />
          </div>

          <Box sx={{ display: "block", gap: "20rem", width: "100%" }}>
            <p className={styles.ques_heading}>{DropDownData?.heading}</p>
            {DropDownData?.fields?.map((list, index) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    // textAlign: "center",
                    gap: list?.fields === "volume" ? "7px" : "20px",
                    padding: "6px",
                  }}
                >
                  <FormControl sx={{ display: "block" }}>
                    <RadioGroup
                      name={`${DropDownData?.fieldName}.${list.fields}.${list.listFields}`}
                      //   value={radiobtn?.mass}
                      value={
                        data?.[DropDownData?.fieldName]?.[list?.fields]?.[
                          list?.subfileds
                        ] || ""
                      }
                      onChange={(e) => handleRadioChange(e, tableindex)}
                      //   onChange={(e) =>
                      //     handleInputChange(
                      //       tableIndex,
                      //       rowIndex,
                      //       field.fieldName,
                      //       e.target.value,
                      //       field.type
                      //     )
                      //   }
                    >
                      <FormControlLabel
                        value={
                          data?.[DropDownData?.fieldName]?.[list?.fields]?.[
                            list?.subfileds
                          ]
                        }
                        control={<Radio />}
                        label={list?.title}
                        disabled={disabled}
                      />
                    </RadioGroup>
                  </FormControl>
                  <Select
                    sx={{ width: "26%", height: "2rem" }}
                    name={`${DropDownData?.fieldName}.${list.fields}.${list.listFields}`}
                    value={
                      data?.[DropDownData?.fieldName]?.[list.fields]?.[
                        list.listFields
                      ]
                    }
                    placeholder="Select"
                    onChange={(e) => handleChangeselectTable(e, tableindex)}
                    displayEmpty
                    size="small"
                    disabled={
                      !data?.[DropDownData?.fieldName]?.[list?.fields]
                        ?.active || disabled
                    }
                  >
                    <MenuItem value="">
                      <em>Select</em>
                    </MenuItem>
                    {list?.list?.map((data, index) => (
                      <MenuItem key={index} value={data}>
                        {data}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              );
            })}

            {addTables.length > 1 && (
              <Box textAlign="right">
                <Dialog
                  open={deleteDilog}
                  onClose={() => setDeleteDialog(false)}
                >
                  <DialogTitle>Confirm Delete</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Do you really want to delete this entry?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => setDeleteDialog(false)}
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      // onClick={handleDeleteAggree}
                      onClick={()=>handleDeleteCountry()}
                      color="secondary"
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </Dialog>
                <IconButton disabled={disabled} onClick={() =>{ setDeleteDialog(true)
                  setDeleteIndex(tableindex)
                }} color="error">
                  <DeleteIcon />
                </IconButton>
              </Box>
            )}
          </Box>
          {inputData?.map((section, tableIndex) => (
            <TableContainer
              key={section.fieldName}
              component={Paper}
              sx={{
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                mt: "2rem",
                borderRadius: "10px",
              }}
            >
              <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
                <TableHead>
                  <TableRow
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#1C486B",
                      border: "1px solid #ddd",
                    }}
                  >
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "15rem",
                      }}
                    >
                      {"Sr. No."}
                    </TableCell>
                    <TableCell
                      sx={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: "40rem",
                      }}
                    >
                      {section?.defalut}
                    </TableCell>
                    {section.fields?.map((field) => (
                      <TableCell
                        key={field.fieldName}
                        sx={{
                          border: "1px solid #ddd",
                          fontWeight: "bold",
                          color: "#FFFFFF",
                          width: "40rem",
                        }}
                      >
                        {field.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {defaultSegments?.map((segment, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {console.log( segment?.width,"segment?.width")}
                      {/* Handle SNo. properly for Total row */}
                      <TableCell sx={{width: segment?.width ? segment?.widthn:"14%",textAlign:"center"}}>
                        {segment?.title?.includes("Total")
                          ? ""
                          : `${
                              segment?.romanindex
                                ? segment?.romanindex
                                : rowIndex + 1
                            }.`}
                      </TableCell>
                      
                      <TableCell
                        sx={{
                          border: "1px solid #DBDBDB",
                          py: "0.5rem",
                          width: section?.colwidth ? section?.colwidth : "63%",
                          maxWidth: "100%",
                          background: segment?.title?.includes("Total")
                            ? "#EFEFEF"
                            : "white",
                        }}
                      >
                        {segment.title}
                      </TableCell>

                      {section.fields?.map((field, index) => {
                        return (
                          <TableCell
                            key={index}
                            sx={{
                              border: "1px solid #DBDBDB",
                              py: "0.5rem",
                              width: field?.width ? field?.width : section?.colwidth
                                ? section?.colwidth
                                : "63%",
                              maxWidth: "100%",
                              background: "white",
                            }}
                          >
                            <Box sx={{ minWidth: "100px" }}>
                              {field?.type === "select" ? (
                                <Select
                                  sx={{
                                    height: "2rem",
                                    border: "none",
                                    boxShadow: "none", // Ensures no shadow appears
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none", // Removes default MUI border
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        border: "none", // Ensures no border on hover
                                      },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        border: "none", // Removes border on focus
                                      },
                                  }}
                                  name={`${segment?.field}.${field.fieldName}`}
                                  value={
                                    data?.[segment?.field]?.[field.fieldName]
                                  }
                                  placeholder="Select"
                                  onChange={(e) =>
                                    handleChangeTable(e, tableindex)
                                  }
                                  displayEmpty
                                  size="small"
                                  fullWidth
                                  disabled={disabled}
                                  // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
                                >
                                  <MenuItem value="">
                                    <em>Select</em>
                                  </MenuItem>
                                  {field?.list?.map((data, index) => (
                                    <MenuItem key={index} value={data}>
                                      {data}
                                    </MenuItem>
                                  ))}
                                </Select>
                              ) : (
                                <TextField
                                  sx={{ width: "100%" }}
                                  name={`${segment?.field}.${field.fieldName}`}
                                  value={
                                    data?.[segment?.field]?.[field.fieldName]
                                  }
                                  placeholder={"Enter Text"}
                                  disabled={disabled || field?.fieldName==="percentage"?true:false}
                                  type="text"
                                  multiline
                                  minRows={1}
                                  size="small"
                                  variant="standard"
                                  InputProps={{ disableUnderline: true }}
                                  // disabled={segment?.title === "Total"} // Prevent editing "Total" row
                                  onChange={(e) =>
                                    field?.type === "number"
                                      ? handleChangeNumberTable(e, tableindex)
                                      : handleChangeTable(e, tableindex)
                                  }
                                />
                              )}
                            </Box>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ))}
          {tableindex === addTables.length - 1 && (
            <Box textAlign="right">
              {!hide &&
              <Button
                variant="contained"
                onClick={handleAdd}
                disabled={isFilleds?.[tableindex] || disabled}
                sx={{
                  mt: "1rem",
                  backgroundColor: "#1C486B",
                  // border: "1px solid #1C486B",
                  color: "white",
                }}
              >
                <AddIcon color="white" />
                Add Another Product
              </Button>
}
            </Box>
          )}

          <Typography
            variant="body2"
            color="error"
            // key={`${rowIdx}-${field}-${idx}`}
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "12px",
              fontWeight: 600,
            }}
          ></Typography>
        </Box>
      ))}
    </>
  );
};
export default AddTable;
